import { jsx as _jsx } from "react/jsx-runtime";
import Box from "@mui/material/Box";
export function AttributeGroupContent(props) {
    return _jsx(Box, { className: "attribute-group-content", children: props.children });
}
//# sourceMappingURL=AttributeGroupContent.js.map